import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  content: {},
  inner: {
    ...dFlex('initial', 'start'),
    gap: 8,
  },
  icon: {
    paddingTop: 2,
    minWidth: 24,
  },
  list: {
    ...dFlex('center', 'start'),
    flexDirection: 'column',
    gap: 4,
    marginTop: 8,

    span: {
      paddingRight: 4,
    },
  },
  docsIcon: {
    width: 16,

    path: {
      fill: theme.primary.p2,
    },
  },
  learnMore: {
    ...dFlex('start'),
    gap: 4,
    marginTop: 8,
  },
}));

export default useStyles;
